jQuery(document).ready(function($) {
    const modalTriggerBtn = $('.open-modal-btn');
    const modalTitle = $('.custom-message-modal-title');
    const modalFooter = $('.custom-message-modal-footer');
    const modalElement = $('.custom-message-modal-overlay');
    const modalCross = $('.custom-message-modal-close');
    const modalMessage = $('.custom-message-modal-body');
    
    function employerSingleEmployerModal() {
        if( modalMessage ) modalMessage.text('Applying Filter...');
        if( modalTitle ) modalTitle.text('Please Wait');
        if( modalFooter ) modalFooter.text('');
        if( modalElement ) modalElement.addClass('processing');
        if( modalCross ) modalCross.hide();
        if( modalTriggerBtn ) modalTriggerBtn.click();
    }

    $('#review-filter').on('change', function() {
        const filterValue = $(this).val();
        const employer = $('#employer').val();
        employerSingleEmployerModal();

        $.ajax({
            url: ajax_callback_data.ajax_url,
            type: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: {
                action: 'employer_single_filter_option',
                employer: employer,
                filter: filterValue,
                nonce: ajax_callback_data.ajax_nonce
            },
            success: function(response) {
                console.log(response)
                if( modalElement ) modalElement.removeClass('processing');
                if( modalCross ) modalCross.click();

                if (response.success && response.data.review) {
                    $('.recieved-reviews').html(response.data.review);
                    // console.log(response.data.review);
                }
            },
            error: function(xhr, status, error) {
                console.error("AJAX Error:", error);
                if( modalElement ) modalElement.removeClass('processing');
                if( modalCross ) modalCross.click();
            }
        });
    });
});